import type { RateProps } from 'antd'
import { Rate } from 'antd'
import type React from 'react'
import { forwardRef } from 'react'
import StarIcon from './StarIcon'

export interface UiRateProps extends RateProps {
  starSize?: number
}

const DEFAULT_TOOLTIPS = ['1 sao', '2 sao', '3 sao', '4 sao', '5 sao']

const UiRate = forwardRef<React.ComponentRef<typeof Rate>, UiRateProps>(
  ({ count = 5, tooltips = DEFAULT_TOOLTIPS, starSize = 26, style, disabled, ...props }, ref) => {
    return (
      <Rate
        ref={ref}
        count={count}
        tooltips={tooltips}
        disabled={disabled}
        character={({ value, index }) => {
          const isFilled = (index ?? 0) < (value ?? 0)
          return <StarIcon size={starSize} filled={isFilled} />
        }}
        style={{
          lineHeight: 1,
          ...style,
        }}
        {...props}
      />
    )
  }
)

UiRate.displayName = 'UiRate'

export default UiRate
export { StarIcon }
